<template>
  <div>
    <el-dialog :title="$t('billingPage.transactionDetail')" :visible.sync="drawer">
      <el-table :data="tableData" style="width: 100%" border>
        <!-- <el-table-column prop="orderId" :label="$t('billingPage.orderID')" align="center"> </el-table-column>
        <el-table-column prop="billCategory.version" :label="$t('billingPage.Version')" align="center"> </el-table-column> -->
        <el-table-column prop="poId" :label="$t('billingPage.POID')" align="center"> </el-table-column>
        <el-table-column prop="orderId" :label="$t('billingPage.OrderNumber')" align="center"> </el-table-column>
        <el-table-column prop="returnOrderId" :label="$t('billingPage.ReturnOrder')" align="center"> </el-table-column>
        <el-table-column prop="logisticsNumber" :label="$t('CustomerFunction.common.logisticsNo')" align="center"> </el-table-column>
        <!-- <el-table-column prop="skuId" :label="$t('billingPage.SKUID')" align="center"> </el-table-column> -->
        <el-table-column prop="description" :label="$t('billingPage.comments')" align="center" width="93"> </el-table-column>
        <el-table-column prop="gmtCreate" :label="$t('billingPage.createTime')" align="center" width="99"> </el-table-column>
        <el-table-column prop="createdBy" :label="$t('billingPage.createdAt')" align="center" width="87"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      drawer: false,
      tableData: [],
    };
  },
  methods: {
    hide() {
      this.drawer = false;
    },
    /** 关闭弹窗 */
    handleClose(done) {},
    /** 取消 */
    onCancel() {
      this.hide();
    },
  },
};
</script>
<style lang="scss">
.flex-item {
  width: 200px;
  justify-content: space-between;
  align-items: flex-start;
}
.el-drawer__body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.el-form {
  flex: 1;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
</style>
